document.addEventListener("DOMContentLoaded", () => {
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	if (prefersReducedMotion) return;

	import("../../../assets/js/gsap.js").then(({ gsap, ScrollTrigger }) => {
		document.querySelectorAll(".timeline-event").forEach((event) => {
			gsap.set(event, { opacity: 0, x: -60 });

			ScrollTrigger.create({
				trigger: event,
				start: "top 80%",
				once: true,
				onEnter: () => {
					gsap.to(event, {
						opacity: 1,
						x: 0,
						duration: 0.75,
						ease: "sine.inOut",
					});
				},
			});
		});
	});
});
